var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-block"},[_c('font-awesome-icon',{attrs:{"icon":['fas','circle'],"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }